module.exports = __webpack_public_path__ + "static/media/iron.624e4a4a.png";